import React from "react"

const Footer = () => { 

    return (  
    <footer className="footer">
        <div>
            <p>© 2024 By Def-Software </p>
        </div>
    </footer>
    );

    }


export default Footer;